import React from 'react'
import Layout from '../components/layout'
import { graphql } from "gatsby"
import SEO from "../components/seo"
 const Kontakt = (props) =>(
<Layout title={props.data.site.siteMetadata.title}>
<div style=
{{
   display:'flex',
   flexDirection:'column',
   justifyContent:'flex-start',
   alignItems: 'center'
}}>
<SEO title="Übernachten in Bacharach"
          keywords={[`Kontakt`,`Stadtmauer Bacharach`, `Welterbe Mittelrheintal`, `Frackgalerie`, `Urlaub machen`]}
        />
    <h1>
        Gästezimmer Karin Leue
    </h1>
    <p>Langstr. 36 
    </p>
    <p>55422 Bacharach</p>
   <p> Telefon 0175/ 1074707</p>
   <a href="mailto:wohnen-im-mittelrheintal@gmx.de">
                    wohnen-im-mittelrheintal@gmx.de</a>
                    <br/><br/>
   </div>
   </Layout>
)
export default Kontakt


 export const kontaktQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
}`
